import { UserCompany, UserData } from "@/Contracts/Users";
import React, { createContext } from "react";
import { CurrentGuideProgress } from "../reducers";

interface FeatureFlag {
	isOnboardingEnabled: boolean;
}
interface Config {
	userData: UserData | null;
	signUpInitiatingVendor: string;
	userCompany?: UserCompany | null;
	skipOnboarding?: boolean;
}

interface Handles {
	handleRedirect: (progress: CurrentGuideProgress, entityId: string) => void;
}

export interface ParentContextProps {
	featureFlag: FeatureFlag;
	config: Config;
	handles: Handles;
}

export const defaultParentContextProps: ParentContextProps = {
	featureFlag: {
		isOnboardingEnabled: false
	},
	config: {
		userData: null,
		signUpInitiatingVendor: "",
		skipOnboarding: false
	},
	handles: {
		handleRedirect: function () {
			throw new Error("Function not implemented");
		}
	}
};

export const ParentContext = createContext<ParentContextProps | null>(
	null as any
);

export const OnboardingProvider: React.FC<ParentContextProps> = ({
	children,
	...rest
}) => {
	return (
		<ParentContext.Provider value={{ ...rest }}>
			{children}
		</ParentContext.Provider>
	);
};
